const isDev = process.env.NODE_ENV !== 'production';

// Axios
const MAIN_REQUEST_URL = 'https://production.gokidly.com/';
const EDUCATION_REQUEST_URL = `${MAIN_REQUEST_URL}education/api/v3`;

// Global

const MAIN_CDN_URL = 'https://files.gokidly.com/';

export {
  MAIN_REQUEST_URL,
  EDUCATION_REQUEST_URL,
  MAIN_CDN_URL,
  isDev
};
